import React, { useState, useEffect, Suspense, lazy } from 'react';
import { CUSTOM_KEYFRAMES } from './ColorConfig';
import { trackEvent } from '../../../utils/clarity';
// Componentes críticos carregados imediatamente (above the fold)
import Hero from './Hero';
import StickyCtaBar from './StickyCtaBar';
// Lazy loading para componentes abaixo da dobra
var Dor = lazy(function () { return import('./Dor'); });
var Beneficios = lazy(function () { return import('./Beneficios'); });
var OnboardingSection = lazy(function () { return import('./OnboardingSection'); });
var Features = lazy(function () { return import('./Features'); });
var Calculadora = lazy(function () { return import('./Calculadora'); });
var ProvaSocial = lazy(function () { return import('./ProvaSocial'); });
var Planos = lazy(function () { return import('./Planos'); });
var Faq = lazy(function () { return import('./Faq'); });
var CtaFinal = lazy(function () { return import('./CtaFinal'); });
// Componente de loading simples
var SectionLoader = function () { return (React.createElement("div", { className: "flex items-center justify-center py-16" },
    React.createElement("div", { className: "w-12 h-12 border-4 border-green-600/30 border-t-green-500 rounded-full animate-spin" }))); };
var LP_HeroSection = function () {
    var _a = useState(10), clientCount = _a[0], setClientCount = _a[1];
    // ✅ Rastreia visualização da landing page
    useEffect(function () {
        trackEvent('landing_hero_page_viewed');
    }, []);
    useEffect(function () {
        var maxScroll = 0;
        var handleScroll = function () {
            var scrollPercent = Math.round((window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100);
            if (scrollPercent > maxScroll) {
                maxScroll = scrollPercent;
                // Rastreia marcos importantes
                if (scrollPercent >= 25 && maxScroll < 50) {
                    trackEvent('landing_scroll_25');
                }
                else if (scrollPercent >= 50 && maxScroll < 75) {
                    trackEvent('landing_scroll_50');
                }
                else if (scrollPercent >= 75 && maxScroll < 90) {
                    trackEvent('landing_scroll_75');
                }
                else if (scrollPercent >= 90) {
                    trackEvent('landing_scroll_90');
                }
            }
        };
        window.addEventListener('scroll', handleScroll);
        return function () { return window.removeEventListener('scroll', handleScroll); };
    }, []);
    useEffect(function () {
        var exitIntentTriggered = false;
        var handleMouseLeave = function (e) {
            // Detecta quando cursor vai para o topo (tentativa de fechar aba)
            if (e.clientY <= 0 && !exitIntentTriggered) {
                exitIntentTriggered = true;
                trackEvent('landing_exit_intent_detected');
                // Opcional: Mostrar popup de desconto/retenção
            }
        };
        document.addEventListener('mouseleave', handleMouseLeave);
        return function () { return document.removeEventListener('mouseleave', handleMouseLeave); };
    }, []);
    return (React.createElement("div", { className: "relative min-h-screen bg-gray-900 text-white overflow-hidden" },
        React.createElement("div", { className: "absolute inset-0 bg-gradient-to-br from-green-900/5 via-blue-900/5 to-purple-900/5 pointer-events-none" }),
        React.createElement("div", { className: "absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-green-900/10 via-transparent to-transparent pointer-events-none" }),
        React.createElement("div", { className: "relative z-10" },
            React.createElement(Hero, null),
            React.createElement(Suspense, { fallback: React.createElement(SectionLoader, null) },
                React.createElement(Dor, null)),
            React.createElement(Suspense, { fallback: React.createElement(SectionLoader, null) },
                React.createElement(Beneficios, null)),
            React.createElement(Suspense, { fallback: React.createElement(SectionLoader, null) },
                React.createElement(OnboardingSection, null)),
            React.createElement(Suspense, { fallback: React.createElement(SectionLoader, null) },
                React.createElement(Features, null)),
            React.createElement(Suspense, { fallback: React.createElement(SectionLoader, null) },
                React.createElement(Calculadora, { clientCount: clientCount, setClientCount: setClientCount })),
            React.createElement(Suspense, { fallback: React.createElement(SectionLoader, null) },
                React.createElement(ProvaSocial, null)),
            React.createElement(Suspense, { fallback: React.createElement(SectionLoader, null) },
                React.createElement(Planos, null)),
            React.createElement(Suspense, { fallback: React.createElement(SectionLoader, null) },
                React.createElement(Faq, null)),
            React.createElement(Suspense, { fallback: React.createElement(SectionLoader, null) },
                React.createElement(CtaFinal, null))),
        React.createElement(StickyCtaBar, null),
        React.createElement("style", null, "\n                    ".concat(CUSTOM_KEYFRAMES, "\n                    \n                    @keyframes spin {\n                        to { transform: rotate(360deg); }\n                    }\n\n                    .animate-spin {\n                        animation: spin 1s linear infinite;\n                    }\n\n                    /* Scroll suave */\n                    html {\n                        scroll-behavior: smooth;\n                    }\n\n                    /* Remover anima\u00E7\u00F5es desnecess\u00E1rias em mobile e acessibilidade */\n                    @media (prefers-reduced-motion: reduce) {\n                        *,\n                        *::before,\n                        *::after {\n                            animation-duration: 0.01ms !important;\n                            animation-iteration-count: 1 !important;\n                            transition-duration: 0.01ms !important;\n                            scroll-behavior: auto !important;\n                        }\n                    }\n\n                    /* Otimiza\u00E7\u00E3o de GPU para anima\u00E7\u00F5es */\n                    .hover\\:scale-105:hover {\n                        transform: scale(1.05) translateZ(0);\n                        will-change: transform;\n                    }\n                "))));
};
export default LP_HeroSection;
